module.exports = __webpack_public_path__ + "static/media/add.39d14924.svg";